

$(document).ready(function(){


    if ($(window).width() < 990){
       $('.relatedArticles .inner').addClass('swiper');
      $('.relatedArticles .wrap').addClass('swiper-wrapper');
      $('.relatedArticles .well').addClass('swiper-slide');
      $('.relatedArticles .inner').append(' <div class="swiper-pagination"></div>');
      
       var swiper = new Swiper(".relatedArticles .inner", {
         slidesPerView: 1,
      spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
        },
      });

     
    }


  
  $('.home-tabs-with-image .tab-item2').click(function(){
    $('.home-tabs-with-image .tabs h4').removeClass('active');
    $('.home-tabs-with-image .content>div').removeClass('active');
    $('.home-tabs-with-image .right img').removeClass('active');

  //  $('.home-tabs-with-image .right img').fadeOut();
    
    $('.home-tabs-with-image .tab-item2').addClass('active');
    $('.home-tabs-with-image .content .text2').addClass('active');
   $('.home-tabs-with-image .right .image2').addClass('active');
     //   $('.home-tabs-with-image .right .image2').fadeIn();
  });
  $('.home-tabs-with-image .tab-item1').click(function(){
    $('.home-tabs-with-image .tabs h4').removeClass('active');
    $('.home-tabs-with-image .content>div').removeClass('active');
   $('.home-tabs-with-image .right img').removeClass('active');
   //     $('.home-tabs-with-image .right img').fadeOut();
    $('.home-tabs-with-image .tab-item1').addClass('active');
    $('.home-tabs-with-image .content .text1').addClass('active');
    $('.home-tabs-with-image .right .image1').addClass('active');
     //       $('.home-tabs-with-image .right .image1').fadeIn();
  });
  $('.home-tabs-with-image .tab-item3').click(function(){
    $('.home-tabs-with-image .tabs h4').removeClass('active');
    $('.home-tabs-with-image .content>div').removeClass('active');
    $('.home-tabs-with-image .right img').removeClass('active');
 //       $('.home-tabs-with-image .right img').fadeOut();
    $('.home-tabs-with-image .tab-item3').addClass('active');
    $('.home-tabs-with-image .content .text3').addClass('active');
    $('.home-tabs-with-image .right .image3').addClass('active');
   //         $('.home-tabs-with-image .right .image3').fadeIn();
  });



 $('.product-tabs-section .tab-item1').click(function(){
    $('.product-tabs-section .tabs h4').removeClass('active');
    $('.product-tabs-section .content > div').removeClass('active');
    $('.product-tabs-section .right img').removeClass('active');
    $('.product-tabs-section .tab-item1').addClass('active');
    $('.product-tabs-section .content .text1').addClass('active');
    $('.product-tabs-section .right .image1').addClass('active');
  });
 $('.product-tabs-section .tab-item2').click(function(){
    $('.product-tabs-section .tabs h4').removeClass('active');
    $('.product-tabs-section .content > div').removeClass('active');
    $('.product-tabs-section .right img').removeClass('active');
    $('.product-tabs-section .tab-item2').addClass('active');
    $('.product-tabs-section .content .text2').addClass('active');
    $('.product-tabs-section .right .image2').addClass('active');
  });
 $('.product-tabs-section .tab-item3').click(function(){
    $('.product-tabs-section .tabs h4').removeClass('active');
    $('.product-tabs-section .content > div').removeClass('active');
    $('.product-tabs-section .right img').removeClass('active');
    $('.product-tabs-section .tab-item3').addClass('active');
    $('.product-tabs-section .content .text3').addClass('active');
    $('.product-tabs-section .right .image3').addClass('active');
  });
 $('.product-tabs-section .tab-item4').click(function(){
    $('.product-tabs-section .tabs h4').removeClass('active');
    $('.product-tabs-section .content > div').removeClass('active');
    $('.product-tabs-section .right img').removeClass('active');
    $('.product-tabs-section .tab-item4').addClass('active');
    $('.product-tabs-section .content .text4').addClass('active');
    $('.product-tabs-section .right .image4').addClass('active');
  });
 $('.product-tabs-section .tab-item5').click(function(){
    $('.product-tabs-section .tabs h4').removeClass('active');
    $('.product-tabs-section .content > div').removeClass('active');
    $('.product-tabs-section .right img').removeClass('active');
    $('.product-tabs-section .tab-item5').addClass('active');
    $('.product-tabs-section .content .text5').addClass('active');
    $('.product-tabs-section .right .image5').addClass('active');
  });



  $('.faq-tabs .title').click(function(){
    $(this).toggleClass('active');
    $(this).find('span').toggleClass('active');
    $(this).closest('.item').find('.content').toggleClass('active');
  });

  $('.accordion-featured .title').click(function(){
    $(this).toggleClass('active');
    $(this).find('span').toggleClass('active');
    $(this).closest('.item').find('.content').toggleClass('active');
  });


  

  $('.titles .title1').click(function(){
      $('.titles h5').removeClass('active');
      $(this).addClass('active');
      $('.product-tabs .content div').removeClass('active');
      $('.product-tabs .content .text1').addClass('active');
  });
    $('.titles .title2').click(function(){
      $('.titles h5').removeClass('active');
      $(this).addClass('active');
      $('.product-tabs .content div').removeClass('active');
      $('.product-tabs .content .text2').addClass('active');
  });
    $('.titles .title3').click(function(){
      $('.titles h5').removeClass('active');
      $(this).addClass('active');
      $('.product-tabs .content div').removeClass('active');
      $('.product-tabs .content .text3').addClass('active');
  });



  
$('main section').addClass('element-animation');
$('main .shopify-section').addClass('element-animation');

  
 //scroll animation
function onEntry(entry) {
    entry.forEach(change => {
      if (change.isIntersecting) {
       change.target.classList.add('element-show');
      }
    });
  }
  
  let options = {
    threshold: [0.2] };
  let observer = new IntersectionObserver(onEntry, options);
  let elements = document.querySelectorAll('.element-animation');
  
  for (let elm of elements) {
    observer.observe(elm);
  }

  
  
});

